import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const ServiceInnerWrapper = styled.div.attrs(({ justify, theme }) => ({
  justify: justify ? justify : "flex-start",
  bg: theme.colors.white,
}))`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;

  ${media.lessThan(breakpoints.mobile)`
        flex-direction: column;
    `}

  ${media.greaterThan(breakpoints.mobile)`
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 0;
    `}
    ${media.greaterThan(breakpoints.desktop)`
        justify-content: ${(props) => props.justify};
    `}
`;
